/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profilebillingadd2Inputs */

const en_profilebillingadd2 = /** @type {(inputs: Profilebillingadd2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New billing address`)
};

const de_profilebillingadd2 = /** @type {(inputs: Profilebillingadd2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Rechnungsadresse`)
};

/**
* | output |
* | --- |
* | "New billing address" |
*
* @param {Profilebillingadd2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilebillingadd2 = /** @type {((inputs?: Profilebillingadd2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilebillingadd2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilebillingadd2(inputs)
	return de_profilebillingadd2(inputs)
});
export { profilebillingadd2 as "profileBillingAdd" }